module.exports = __webpack_public_path__ + "img/miset4.b827ef60.jpg";